import Jumbotron from "components/Jumbotron";
import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import OurServiceItem from "./components/OurServiceItem";
import { servicesMock } from "./mock/servicesMock";
import { Service } from "./types";

interface OurServicesProps {}

const OurServices: React.FC<OurServicesProps> = ({}) => {
  return (
    <Jumbotron>
      <h3>Нашите услуги</h3>
      <ServicesContainer>
        {servicesMock.map((item: Service) => (
          <OurServiceItem key={item.id} item={item} />
        ))}
      </ServicesContainer>
    </Jumbotron>
  );
};

const ServicesContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;

  div + div {
    padding-top: 20px;
  }

  @media only screen and (${device.tablet}) {
    div + div {
      padding-top: 0;
    }
  }
`;

export default OurServices;
